import * as React from 'react';

import Page from 'components/page/Page';
import SidebarPage from 'components/page/sidebar-page/SidebarPage';
import SettingsSidebar from 'modules/settings/SettingsSidebar';
import { UserNotifications } from '../../components/user-notifications';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./user-notifications-page.i18n.json'));

const UserNotificationsPage = () => (
  <Page documentTitle={__t('user_notifications_page.title')}>
    <SidebarPage
      scrollable
      sidebarWidth="narrow"
      sidebarContent={<SettingsSidebar />}
    >
      <UserNotifications title={__t('user_notifications_page.email_notifications')} />
    </SidebarPage>
  </Page>
);

export default UserNotificationsPage;
